// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sf-5";
export var filledCircle = "_sf-4";
export var historyEntry = "_sf-3";
export var messageSideLeft = "_sf-1";
export var messageSideRight = "_sf-2";
export var orderTrackingCarouselWrapper = "_sf-6";
export var orderTrackingInfoContainer = "_sf-0";